





















import {Component, Prop, Vue} from "vue-property-decorator";
import ButtonWithContext from "../common/ButtonWithContext.vue";
import DotsIcon from '../../../../assets/svg/web-conferences/dots.svg';
import {ContextButtonPosition} from "@share/web-conferences/enums/ContextButtonPosition";
import {StreamTypes} from "@share/web-conferences/enums/StreamTypes";
import {agoraGetter} from "@share/web-conferences/store/getters";
import {AgoraInterface} from "@share/web-conferences/interfaces/AgoraInterface";

@Component({
  name: "ContextControls",
  components: {ButtonWithContext, DotsIcon}
})
export default class ContextControls extends Vue {
  @Prop({required: true}) stateKey: string;
  @Prop({required: true}) userId: number;

  position = ContextButtonPosition.bottomRight;

  get agora(): AgoraInterface {
    return this.$store.getters[agoraGetter](this.stateKey);
  }

  get audioState() {
    return this.agora.tracksManager.audioStates[this.userId] ?? false;
  }

  get videoState() {
    return this.agora.tracksManager.videoStates[this.userId] ?? false;
  }

  get audioLabel() {
    return this.$t(this.audioState ? 'web-conferences.micOff' : 'web-conferences.micOn');
  }

  get videoLabel() {
    return this.$t(this.videoState ? 'web-conferences.videoOff' : 'web-conferences.videoOn');
  }

  streamChanged(streamType: StreamTypes) {
    const isEnabled = !(streamType == StreamTypes.Audio ? this.audioState : this.videoState);
    this.$emit('streamChanged', streamType, isEnabled);
    (this.$refs['buttonWithContext'] as ButtonWithContext).hide();
  }
}
